import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { postLoginWithGoogle } from '../../services/auth/authAxios/authAxios';
import config from '../../config/environment';
import { handleApi } from '../../utils/handleApi';

function GoogleLoginButton() {
  const { login } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    setIsLoading(true);

    const client = window.google.accounts.oauth2.initTokenClient({
      client_id: config.googleLoginScope,
      scope: 'openid email profile',
      callback: async (tokenResponse) => {
        const { res, error } = await handleApi(
          postLoginWithGoogle({ token: tokenResponse.access_token })
        );

        if (error) {
          setIsLoading(false);
          return;
        }

        if (res) {
          login(res.access_token, res.refresh_token);
        }

        setIsLoading(false);
      },
      error_callback: (error) => {
        console.error('Google auth error:', error);
        setIsLoading(false);
      },
    });

    client.requestAccessToken();
  };

  React.useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
      <button 
        onClick={handleLogin}
        disabled={isLoading}
        className={`flex items-center justify-center gap-2 ${
          isLoading ? 'bg-gray-100 text-gray-400' : 'bg-white hover:bg-gray-50 text-gray-700'
        } font-medium rounded-md px-4 py-2 border border-gray-300 shadow-sm`}
        style={{padding:"10px 16px", fontSize:"14px", transition:"all 0.2s"}}
      >
        {isLoading ? (
          <>
            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span>Loading...</span>
          </>
        ) : (
          <>
            <img 
              src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" 
              alt="Google logo" 
              className="w-5 h-5" 
              style={{width:"18px", height:"18px"}}
            />
            <span>Login with Google</span>
          </>
        )}
      </button>
    </div>
  );
}

export default GoogleLoginButton;